export default {"id":"f2f11358","attrs":{"viewBox":"0 0 29 28","width":"29","height":"28"}}